import type { FilterNestedModel } from "@/components/degree-search/FilterCheckboxNested.vue";
import type { FilterInterestAreaSubjects } from "@/src/services/DegreeSearchService";
import { defineStore } from "pinia";
import { computed, ref, type Ref } from "vue";

type FilterType = {
  value: string;
  text: string;
};

export const useProgramFilter = defineStore("program-filter", () => {
  const selectedHighlights = ref<Set<string>>(new Set());
  const selectedDegreeTypes = ref<Set<string>>(new Set());
  const selectedColleges = ref<Set<string>>(new Set());

  const selectedInterestArea = ref<FilterNestedModel>({});
  const selectedSubjectArea = computed<Set<string>>(() => {
    return new Set<string>(
      Object.values(selectedInterestArea.value).flatMap((subject) => {
        return Array.from(subject);
      })
    );
  });

  const setselectedInterestArea = (subjAreaFilter: FilterInterestAreaSubjects[]) => {
    const current = selectedInterestArea.value;
    // check: empty object OR all sets are empty
    const isEmpty =
      Object.keys(current).length === 0 || Object.values(current).every((set) => set.size === 0);
    if (isEmpty) {
      selectedInterestArea.value = subjAreaFilter.reduce<FilterNestedModel>((acc, subjectArea) => {
        acc[subjectArea.value] = new Set<string>();
        return acc;
      }, {});
    }
  };
  const clearAllFilter = () => {
    selectedHighlights.value.clear();
    selectedDegreeTypes.value.clear();
    selectedColleges.value.clear();
    for (const [key] of Object.entries(selectedInterestArea.value)) {
      selectedInterestArea.value[key].clear();
    }
  };
  const syncSetWithAllowedValues = (selected: Ref<Set<string>>, allowedValues: FilterType[]) => {
    const valuesArray = allowedValues.map((item) => item.value);
    const allowed = new Set(valuesArray);
    for (const value of selected.value) {
      if (!allowed.has(value)) {
        selected.value.delete(value);
      }
    }
  };
  // TODO: Update save states to use query parameters instead
  // const saveStates = () => {
  //   // save highlights
  //   if (selectedHighlights.value.size > 0) {
  //     sessionStorage.setItem(
  //       "program-highlights",
  //       JSON.stringify([...selectedHighlights.value])
  //     );
  //   } else {
  //     sessionStorage.removeItem("program-highlights");
  //   }
  //   // save degree types
  //   if (selectedDegreeTypes.value.size > 0) {
  //     sessionStorage.setItem(
  //       "program-degreetypes",
  //       JSON.stringify([...selectedDegreeTypes.value])
  //     );
  //   } else {
  //     sessionStorage.removeItem("program-degreetypes");
  //   }
  //   // save college types
  //   if (selectedColleges.value.size > 0) {
  //     sessionStorage.setItem(
  //       "program-colleges",
  //       JSON.stringify([...selectedColleges.value])
  //     );
  //   } else {
  //     sessionStorage.removeItem("program-colleges");
  //   }
  //   // interest areas
  //   const interestObj = selectedInterestArea.value;
  //   if (
  //     interestObj &&
  //     Object.keys(interestObj).some((k) => interestObj[k].size > 0)
  //   ) {
  //     const serialized = Object.fromEntries(
  //       Object.entries(interestObj).map(([key, set]) => [key, [...set]])
  //     );
  //     sessionStorage.setItem(
  //       "program-interest-areas",
  //       JSON.stringify(serialized)
  //     );
  //   } else {
  //     sessionStorage.removeItem("program-interest-areas");
  //   }
  // };
  const clearSession = () => {
    selectedHighlights.value.clear();
    selectedDegreeTypes.value.clear();
    selectedColleges.value.clear();
    selectedInterestArea.value = {};
    // TODO: figure alternative method to handle this using query parameters
    // sessionStorage.removeItem("program-highlights");
    // sessionStorage.removeItem("program-degreetypes");
    // sessionStorage.removeItem("program-colleges");
    // sessionStorage.removeItem("program-interest-areas");
  };
  // Init Store won't be initiated.
  // TODO: Update initStore to use query params
  // const initStore = () => {
  //   const highlights = sessionStorage.getItem("program-highlights");
  //   const degreeTypes = sessionStorage.getItem("program-degreetypes");
  //   const colleges = sessionStorage.getItem("program-colleges");
  //   const interestAreas = sessionStorage.getItem("program-interest-areas");
  //   if (typeof highlights === "string") {
  //     selectedHighlights.value = new Set(JSON.parse(highlights));
  //   }
  //   if (typeof degreeTypes === "string") {
  //     selectedDegreeTypes.value = new Set(JSON.parse(degreeTypes));
  //   }
  //   if (typeof colleges === "string") {
  //     selectedColleges.value = new Set(JSON.parse(colleges));
  //   }
  //   if (typeof interestAreas === "string") {
  //     const parsed = JSON.parse(interestAreas) as Record<string, string[]>;
  //     selectedInterestArea.value = Object.fromEntries(
  //       Object.entries(parsed).map(([key, arr]) => [key, new Set(arr)])
  //     );
  //   }
  // };

  return {
    selectedHighlights,
    selectedDegreeTypes,
    selectedColleges,
    selectedInterestArea,
    selectedSubjectArea,
    setselectedInterestArea,
    clearAllFilter,
    syncSetWithAllowedValues,
    clearSession
    // initStore,
    // saveStates,
  };
});
